export function currencySymbol(currency?:string):string {

    if (!currency) currency = gd.company.financeCurrency

    if (!currency) currency = 'us_dollar'

    return gd.const.currency[currency]?.symbol;

}